var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70825 1.49658H19.0416V16.6632C19.0416 17.2379 18.8133 17.789 18.407 18.1953C18.0007 18.6016 17.4496 18.8299 16.8749 18.8299H3.87492C3.30028 18.8299 2.74918 18.6016 2.34285 18.1953C1.93653 17.789 1.70825 17.2379 1.70825 16.6632V1.49658Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29159 1.49561H1.70825V16.6623C1.70825 17.2369 1.93653 17.788 2.34285 18.1943C2.74918 18.6007 3.30028 18.8289 3.87492 18.8289H16.8749C17.4496 18.8289 18.0007 18.6007 18.407 18.1943C18.8133 17.788 19.0416 17.2369 19.0416 16.6623V11.2456M7.12492 13.4123L19.0416 1.49561M19.0416 1.49561H13.6249M19.0416 1.49561V6.91227",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliate);
export default __webpack_public_path__ + "static/media/affiliate.6efdbda3ebfee00522dbba19c8295fa5.svg";
export { ForwardRef as ReactComponent };